__turbopack_context__.v({
  "brand": "hero-module-scss-module__uZF6MW__brand",
  "headline": "hero-module-scss-module__uZF6MW__headline",
  "hero": "hero-module-scss-module__uZF6MW__hero",
  "mission": "hero-module-scss-module__uZF6MW__mission",
  "overlayBottom": "hero-module-scss-module__uZF6MW__overlayBottom",
  "overlayTop": "hero-module-scss-module__uZF6MW__overlayTop",
  "panel": "hero-module-scss-module__uZF6MW__panel",
  "panelWrap": "hero-module-scss-module__uZF6MW__panelWrap",
  "video": "hero-module-scss-module__uZF6MW__video",
});
